import { createContext } from 'react';
import {
	IGetModifierGroupInfoV2,
	IItemForGetShortInfoWithStatus,
	IGetModGroupRestaurantProperties,
	TLanguageIDs,
} from 'types';

export type TTypeOfModalWindow =
	| null
	| 'errorUpdatingModifierGroup'
	| 'errorModGroupHasPortions'
	| 'assignRestaurants'
	| 'editModifiersTemplate'
	| 'editInclusive';

export interface IViewModifierGroupState {
	needRefetchData: boolean;
	needRefetchRestPropsData: boolean;
	modifierGroupFullInfo: Nullable<IGetModifierGroupInfoV2>;
	accessibleRestaurants: IItemForGetShortInfoWithStatus[];
	restaurantIdForRestaurantProps: Nullable<string>;
	restaurantProps: Nullable<IGetModGroupRestaurantProperties>;
	selectedTranslationTab: Nullable<TLanguageIDs>;
	typeOfModalWindow: TTypeOfModalWindow;
}

export const viewModifierGroupInitialState: IViewModifierGroupState = {
	needRefetchData: false,
	needRefetchRestPropsData: false,
	modifierGroupFullInfo: null,
	accessibleRestaurants: [],
	restaurantIdForRestaurantProps: null,
	restaurantProps: null,
	selectedTranslationTab: null,
	typeOfModalWindow: null,
};

export interface IViewModifierGroupContext extends IViewModifierGroupState {
	refetchData(value: boolean): void;
	refetchRestPropsData(value: boolean): void;
	setRestaurantIdForRestaurantProps(value: Nullable<string>): void;
	setTranslationTab(value: Nullable<TLanguageIDs>): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
}

export const ViewModifierGroupContext = createContext<IViewModifierGroupContext>({
	refetchData: () => undefined,
	refetchRestPropsData: () => undefined,
	setRestaurantIdForRestaurantProps: () => undefined,
	setTranslationTab: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	...viewModifierGroupInitialState,
});
